export const LMT_ENHCMT_setNoOfStatementReducer = {
  LMT_ENHCMT_setNoOfStatement: (state, action) => {
    state.noOfStatement = action.payload;
  },
};
